import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/global.css'
import 'element-plus/lib/theme-chalk/index.css'
import installElementPlus from './plugins/element'

const app = createApp(App)
installElementPlus(app)
app.mount('#app')
